import { useContext } from "react";
import { GMContext, type GMContextType } from "@/contexts/GMContext";

export function useGMContext(): GMContextType {
  const context = useContext(GMContext);
  if (!context) {
    throw new Error("useGMContext must be used within a GMProvider");
  }
  return context;
}
